import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from '../screens/app';
import Header from '../screens/header';

export default () => (
    <Route component={App}>
        <IndexRoute component={Header} />
        <Route component={Header} path={'*'} />
    </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes/index.js
 **/